import { render, staticRenderFns } from "./NftCollectionTable.vue?vue&type=template&id=79a6e90e&scoped=true"
import script from "./NftCollectionTable.vue?vue&type=script&lang=ts"
export * from "./NftCollectionTable.vue?vue&type=script&lang=ts"
import style0 from "./NftCollectionTable.vue?vue&type=style&index=0&id=79a6e90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6e90e",
  null
  
)

export default component.exports